/* ============================================
   SALVYR Product Reviews — Interaction JS
   Path: assets/salvyr-reviews.js
   Handles: filter tags, star bar filter, lightbox, form modal, scroll to reviews
   ============================================ */

(function () {
  'use strict';

  function initReviews(container) {
    if (!container || container.__salvyrInit) return;
    container.__salvyrInit = true;

    const cards = container.querySelectorAll('.salvyr-review-card');
    const tags = container.querySelectorAll('[data-filter]');
    const starBars = container.querySelectorAll('[data-filter-star]');
    const filterWrap = container.querySelector('.salvyr-reviews__filter-tags');
    const loadMoreBtn = container.querySelector('[data-load-more]');
    const openFormBtns = container.querySelectorAll('[data-open-review-form]');
    const closeFormBtn = container.querySelector('[data-close-review-form]');
    const formModal = container.querySelector('[data-review-form-modal]');

    const PAGE_SIZE = 6;
    let visibleCount = PAGE_SIZE;
    let activeFilter = 'all';
    let activeStarFilter = null;

    /* ===== FILTER LOGIC ===== */
    function applyFilters() {
      let shownCount = 0;
      let matchedTotal = 0;

      cards.forEach((card) => {
        const hasPhotos = card.dataset.hasPhotos === 'true';
        const isVerified = card.dataset.verified === 'true';
        const star = parseInt(card.dataset.star, 10);

        let matches = true;
        if (activeFilter === 'photos' && !hasPhotos) matches = false;
        if (activeFilter === 'verified' && !isVerified) matches = false;
        if (activeStarFilter !== null && star !== activeStarFilter) matches = false;

        if (matches) {
          matchedTotal++;
          if (shownCount < visibleCount) {
            card.classList.remove('is-hidden');
            shownCount++;
          } else {
            card.classList.add('is-hidden');
          }
        } else {
          card.classList.add('is-hidden');
        }
      });

      if (loadMoreBtn) {
        loadMoreBtn.style.display = matchedTotal > visibleCount ? 'block' : 'none';
      }
    }

    /* Filter tag clicks */
    tags.forEach((tag) => {
      tag.addEventListener('click', function () {
        tags.forEach((t) => t.classList.remove('is-active'));
        this.classList.add('is-active');
        activeFilter = this.dataset.filter;
        visibleCount = PAGE_SIZE;
        applyFilters();
      });
    });

    /* Star bar filter clicks */
    starBars.forEach((bar) => {
      bar.addEventListener('click', function () {
        const star = parseInt(this.dataset.filterStar, 10);
        if (activeStarFilter === star) {
          activeStarFilter = null;
          this.style.opacity = '';
        } else {
          activeStarFilter = star;
          starBars.forEach((b) => (b.style.opacity = '0.4'));
          this.style.opacity = '1';
        }
        visibleCount = PAGE_SIZE;
        applyFilters();
      });
    });

    /* Load more */
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        visibleCount += PAGE_SIZE;
        applyFilters();
      });
    }

    /* Initial render */
    applyFilters();

    /* ===== FORM MODAL ===== */
    openFormBtns.forEach((btn) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (formModal) formModal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });

    if (closeFormBtn) {
      closeFormBtn.addEventListener('click', function () {
        if (formModal) formModal.hidden = true;
        document.body.style.overflow = '';
      });
    }

    if (formModal) {
      formModal.addEventListener('click', function (e) {
        if (e.target === formModal) {
          formModal.hidden = true;
          document.body.style.overflow = '';
        }
      });
    }
  }

  /* ===== LIGHTBOX (global, single instance) ===== */
  function initLightbox() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-lightbox-src]');
      if (!btn) return;
      e.preventDefault();

      const src = btn.dataset.lightboxSrc;
      const box = document.createElement('div');
      box.className = 'salvyr-lightbox';
      box.innerHTML = `
        <button class="salvyr-lightbox__close" aria-label="Close">×</button>
        <img src="${src}" alt="Review photo">
      `;
      document.body.appendChild(box);
      document.body.style.overflow = 'hidden';

      const close = () => {
        box.remove();
        document.body.style.overflow = '';
      };

      box.addEventListener('click', close);
      box.querySelector('.salvyr-lightbox__close').addEventListener('click', close);

      const escHandler = (ev) => {
        if (ev.key === 'Escape') {
          close();
          document.removeEventListener('keydown', escHandler);
        }
      };
      document.addEventListener('keydown', escHandler);
    });
  }

  /* ===== RATING SUMMARY — scroll to reviews + open accordion ===== */
  function initRatingSummaryClick() {
    document.addEventListener('click', function (e) {
      const link = e.target.closest('[data-scroll-to-reviews]');
      if (!link) return;
      e.preventDefault();

      // Prestige accordion pattern: <details> tag OR .accordion class
      const accordion = document.querySelector('[data-reviews-accordion]');
      if (accordion) {
        // If <details>, open it
        if (accordion.tagName === 'DETAILS') {
          accordion.open = true;
        } else {
          // Prestige custom accordion: click the trigger
          const trigger = accordion.querySelector('summary, .accordion__toggle, button');
          if (trigger && !accordion.hasAttribute('open')) {
            trigger.click();
          }
        }

        setTimeout(() => {
          accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
      }
    });
  }

  /* ===== INIT ===== */
  function bootstrap() {
    document.querySelectorAll('.salvyr-reviews').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootstrap();
      initLightbox();
      initRatingSummaryClick();
    });
  } else {
    bootstrap();
    initLightbox();
    initRatingSummaryClick();
  }

  /* Shopify theme editor live reload */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.salvyr-reviews').forEach(initReviews);
  });
})();
